/* TALVORE — interacciones propias (prefijo mt-) */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Aparición al hacer scroll */
  function initReveals(raiz) {
    var els = (raiz || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Relojes con la hora real */
  function initRelojes() {
    if (!document.querySelector('[data-mt-vivo]')) return;
    function pintar() {
      var relojes = document.querySelectorAll('[data-mt-vivo]');
      var d = new Date();
      var ms = d.getMilliseconds();
      var s = d.getSeconds() + (reducido ? 0 : ms / 1000);
      var m = d.getMinutes() + s / 60;
      var h = (d.getHours() % 12) + m / 60;
      relojes.forEach(function (r) {
        var hs = r.querySelector('.mt-reloj__h'), mn = r.querySelector('.mt-reloj__m'), sg = r.querySelector('.mt-reloj__s'), f = r.querySelector('.mt-reloj__fecha');
        if (hs) hs.setAttribute('transform', 'rotate(' + (h * 30).toFixed(2) + ' 200 280)');
        if (mn) mn.setAttribute('transform', 'rotate(' + (m * 6).toFixed(2) + ' 200 280)');
        if (sg) sg.setAttribute('transform', 'rotate(' + (s * 6).toFixed(2) + ' 200 280)');
        if (f) f.textContent = d.getDate();
      });
      if (reducido) setTimeout(pintar, 1000); else requestAnimationFrame(pintar);
    }
    pintar();
  }

  /* Inclinación suave del reloj del hero con el ratón */
  function initParallax() {
    if (reducido) return;
    document.querySelectorAll('[data-mt-parallax]').forEach(function (zona) {
      var obj = zona.querySelector('.mt-hero__reloj');
      var fuerza = parseFloat(zona.getAttribute('data-mt-parallax')) || 0;
      if (!obj || !fuerza) return;
      zona.addEventListener('mousemove', function (e) {
        var r = zona.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        obj.style.transform = 'perspective(900px) rotateY(' + (x * fuerza) + 'deg) rotateX(' + (-y * fuerza) + 'deg) translate3d(' + (x * fuerza) + 'px,' + (y * fuerza) + 'px,0)';
      });
      zona.addEventListener('mouseleave', function () { obj.style.transform = ''; });
    });
  }

  /* Texto que se ilumina palabra a palabra */
  function initManifiesto() {
    document.querySelectorAll('[data-mt-palabras]').forEach(function (el) {
      if (el.dataset.mtListo) return;
      el.dataset.mtListo = '1';
      if (reducido) return;
      var nodos = Array.prototype.slice.call(el.childNodes);
      nodos.forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var s = document.createElement('span'); s.className = 'mt-palabra'; s.textContent = p; frag.appendChild(s);
          });
          el.replaceChild(frag, n);
        } else if (n.nodeType === 1) {
          n.classList.add('mt-palabra');
        }
      });
      var palabras = el.querySelectorAll('.mt-palabra');
      function act() {
        var r = el.getBoundingClientRect(), vh = window.innerHeight;
        var p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
        var n = Math.round(p * palabras.length);
        palabras.forEach(function (w, i) { w.classList.toggle('mt-on', i < n); });
      }
      window.addEventListener('scroll', act, { passive: true });
      act();
    });
  }

  /* Escena sticky: rasgo activo + anillo de progreso */
  function initDetalle() {
    document.querySelectorAll('.mt-detalle').forEach(function (sec) {
      var rasgos = sec.querySelectorAll('.mt-rasgo');
      var visual = sec.querySelector('.mt-detalle__visual');
      var reloj = sec.querySelector('.mt-detalle__visual .mt-reloj');
      if (!rasgos.length) return;
      function act() {
        var vh = window.innerHeight, activo = 0;
        rasgos.forEach(function (r, i) { if (r.getBoundingClientRect().top < vh * 0.55) activo = i; });
        rasgos.forEach(function (r, i) { r.classList.toggle('mt-activo', i === activo); });
        var rr = sec.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, -rr.top / Math.max(1, rr.height - vh)));
        if (visual) visual.style.setProperty('--mt-p', p.toFixed(3));
        if (reloj && !reducido) reloj.style.transform = 'rotate(' + (p * 24 - 12) + 'deg) scale(' + (1 + p * 0.06) + ')';
      }
      window.addEventListener('scroll', act, { passive: true });
      act();
    });
  }

  /* Cifras que cuentan */
  function initCifras() {
    var els = document.querySelectorAll('[data-mt-contar]:not([data-mt-hecho])');
    if (!els.length) return;
    function contar(el) {
      el.setAttribute('data-mt-hecho', '1');
      var fin = parseFloat(String(el.getAttribute('data-mt-contar')).replace(',', '.'));
      if (isNaN(fin) || reducido) return;
      var dec = (String(el.getAttribute('data-mt-contar')).split(/[.,]/)[1] || '').length;
      var t0 = null, dur = 1800;
      function paso(t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 4);
        el.textContent = (fin * e).toFixed(dec).replace('.', ',');
        if (k < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
      setTimeout(function () { el.textContent = String(fin.toFixed(dec)).replace('.', ','); }, dur + 400);
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { contar(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Página de producto: galería, variantes y cantidad */
  function initProducto() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (raiz) {
      var principal = raiz.querySelector('.mt-galeria__principal img');
      raiz.querySelectorAll('.mt-galeria__mini').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!principal) return;
          principal.style.opacity = 0;
          setTimeout(function () {
            principal.src = b.getAttribute('data-src');
            principal.srcset = '';
            principal.alt = b.getAttribute('data-alt') || '';
            principal.style.opacity = 1;
          }, 180);
          raiz.querySelectorAll('.mt-galeria__mini').forEach(function (x) { x.classList.remove('mt-activo'); });
          b.classList.add('mt-activo');
        });
      });

      var cant = raiz.querySelector('.mt-cantidad input');
      raiz.querySelectorAll('.mt-cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cant.value, 10) || 1;
          cant.value = Math.max(1, v + (b.getAttribute('data-mt-paso') === '+' ? 1 : -1));
        });
      });

      var datos = raiz.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var idInput = raiz.querySelector('input[name="id"]');
      var precio = raiz.querySelector('[data-mt-precio]');
      var tachado = raiz.querySelector('[data-mt-tachado]');
      var boton = raiz.querySelector('[data-mt-boton]');
      var txtBoton = boton ? boton.querySelector('span') : null;
      var formato = raiz.getAttribute('data-mt-moneda') || '{{amount_with_comma_separator}} €';
      function dinero(c) {
        var n = (c / 100).toFixed(2), partes = n.split('.');
        var miles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, miles + ',' + partes[1])
          .replace(/\{\{\s*amount\s*\}\}/, partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + partes[1])
          .replace(/\{\{\s*amount_no_decimals(_with_comma_separator)?\s*\}\}/, miles);
      }
      raiz.querySelectorAll('.mt-opcion input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var elegidas = [];
          raiz.querySelectorAll('.mt-opcion').forEach(function (fs) {
            var c = fs.querySelector('input:checked'); elegidas.push(c ? c.value : null);
          });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
          if (!v) {
            if (boton) boton.disabled = true;
            if (txtBoton) txtBoton.textContent = boton.getAttribute('data-txt-nodisp');
            return;
          }
          idInput.value = v.id;
          if (precio) precio.textContent = dinero(v.price);
          if (tachado) {
            tachado.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : '';
          }
          if (boton) {
            boton.disabled = !v.available;
            if (txtBoton) txtBoton.textContent = v.available ? boton.getAttribute('data-txt-ok') : boton.getAttribute('data-txt-agotado');
          }
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
          if (v.featured_media && principal) {
            var mini = raiz.querySelector('.mt-galeria__mini[data-id="' + v.featured_media.id + '"]');
            if (mini) mini.click();
          }
        });
      });
    });
  }

  function iniciar() {
    initReveals(); initRelojes(); initParallax(); initManifiesto(); initDetalle(); initCifras(); initProducto();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', function () {
    initReveals(); initManifiesto(); initDetalle(); initCifras(); initProducto(); initParallax();
  });
})();
